import Vue from 'vue';
import BigNumber from 'bignumber.js';
import createRouter from './router';
// import VTooltip from 'v-tooltip';
import App from './App.vue';

import '@/assets/style/reset.scss';
import '@/assets/style/style.scss';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import BootstrapVue, { BootstrapVueIcons, ToastPlugin } from 'bootstrap-vue';
import store from './store';
import VueRouter from 'vue-router';
import Toasted from 'vue-toasted';
import config from '@/config';
import moment from 'moment';
import { ValidateException, HttpException } from '@/exceptions';

import Jazzicon from 'vue-jazzicon';
import VCalendar from 'v-calendar';
import BootstrapVueDialog from 'bootstrap-vue-dialog';
import VTooltip from 'v-tooltip';

declare global {
  interface Window {
    isMobile: any;
  }
}

Vue.use(BootstrapVueDialog);

BigNumber.config({ ROUNDING_MODE: BigNumber.ROUND_DOWN });
BigNumber.config({ EXPONENTIAL_AT: 100 });

const router = createRouter();

window.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  navigator.userAgent
);

Vue.use(VCalendar);
Vue.use(BootstrapVue);
Vue.use(ToastPlugin);
Vue.use(BootstrapVueIcons);
Vue.use(VTooltip);
Vue.use(Toasted, { iconPack: 'fontawesome' });
Vue.use(VueRouter);
Vue.filter('currencyUSD', function(dec: any) {
  if (new BigNumber(dec || 0).isZero()) return '-';
  let numberStr = new BigNumber(dec).toFixed(4, BigNumber.ROUND_DOWN);
  numberStr = new BigNumber(numberStr).toString();

  return new BigNumber(numberStr).toFormat();
});

Vue.filter('formatWeiAmount', function(
  wei: any,
  roundMode = BigNumber.ROUND_HALF_CEIL
) {
  if (new BigNumber(wei || 0).isZero()) return '0';
  let numberStr = new BigNumber(wei).dividedBy(1e18).toFixed(4, roundMode);
  numberStr = new BigNumber(numberStr).toString();

  return new BigNumber(numberStr).toFormat();
});

Vue.filter('formatNumber', function(dec: any) {
  if (new BigNumber(dec || 0).isZero()) return '-';
  let numberStr = new BigNumber(dec).toFixed(4, BigNumber.ROUND_DOWN);
  numberStr = new BigNumber(numberStr).toString();

  return new BigNumber(numberStr).toFormat();
});

Vue.filter('blockchainAddress', function(address: any) {
  return address
    ? `${address.slice(0, 6)}...${address.slice(address.length - 4)}`
    : address;
});

Vue.filter('transformToCurrencyName', function(address: any) {
  if (address === '0x0000000000000000000000000000000000000000') {
    return 'BUNI';
  }
  const supportCurrencies = config.supportCurrencies;
  const currency = supportCurrencies.find((supportCurrency: any) => {
    return supportCurrency.address.toLowerCase() === address.toLowerCase();
  });
  if (currency) {
    return currency.symbol;
  }
  return 'N/A';
});

Vue.filter('formatSecondsToUtcTime', function(
  seconds: any,
  format = 'DD-MM-YYYY HH:mm:ss'
) {
  const time = moment(seconds * 1000)
    .utc()
    .format(format);
  return `${time} (UTC)`;
});

Vue.config.errorHandler = (error: any, vm, info) => {
  if (error instanceof ValidateException) {
    switch (error.type) {
      case 'error':
        return ValidateException.alertError(error, info);
      case 'warning':
        return ValidateException.alertWarning(error, info);
      default:
        return ValidateException.alertError(error, info);
    }
  }
  if (error instanceof HttpException) {
    return HttpException.alertError(error, info);
  }
};

Vue.component('Jazzicon', Jazzicon);
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app');
